export const getAllWidgetsQuery = () => `{
    getAllTypeWidget{  id
                       name 
                       color 
                       icon 
                       is_active 
                       frontOffice
                       backOffice
                       widgets {widgetDes 
                                type_id 
                                endPoint 
                                Token api_host 
                                public_APi 
                                api_host
                                is_reachebale 
                                is_active 
                              }
                      }
   }`;

export const geWidgetsByTypeIdQuery = (id) => `
{
  getWidgetByType(id:${id}){
    id
    widgetDes 
    is_reachebale 
    is_active 
    api_host
    type_id
    Token
    endPoint
    Typewidget{
               id
               name
               color
               icon
               is_active
                 }
    
   }
}

`;

export const getWidgetCredentialsQuery = (type_id) => `{
  getCredentials(type_id:${type_id})
  {
    id 
    public_APi
    type_id
    endPoint
    Token
    is_reachebale
    is_active
    
   }

}`;

export const getHolydaysData = (contryCode) => `
{
  widgetDatum(name:"holiday", opt:{country_code:"${contryCode}"}){
  API_data
  }
 }


`;

export const getWeatherData = (state) => `
{
  widgetDatum(name:"weather",opt:{state:"${state}"}){API_data}
}
`;
